import produce from 'immer';

import {
    INIT_REGISTRATION_FORM,
    SAVE_REGISTRATION_DATA,
    SEND_REGISTRATION_DATA,
    GET_REGISTRATION_SUCCESS,
    HANDLE_INVALID_API_RESPONSE,
    READ_SESSION_STORAGE,
} from './constant';

/**
 * Export initalState
 *
 * @export initalState
 */
export const initialState = {
    loading: false,
    error: false,
    initRegistrationForm: false,
    registrationData: {},
    responseData: {},
};

/**
 *
 * @param {*} state - Initial state of the app
 * @param {*} action - The action dispatched from saga
 */
const glasfaserRegistrationReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case INIT_REGISTRATION_FORM:
                draft.initRegistrationForm = true;
                break;
            case SAVE_REGISTRATION_DATA:
                draft.registrationData = {
                    ...state.registrationData,
                    ...action.update,
                };
                break;
            case SEND_REGISTRATION_DATA:
                draft.loading = true;
                break;
            case GET_REGISTRATION_SUCCESS:
                draft.loading = false;
                draft.initRegistrationForm = false;
                draft.responseData = action.responseData;
                break;
            case HANDLE_INVALID_API_RESPONSE:
                draft.loading = false;
                draft.error = true;
                draft.initRegistrationForm = false;
                break;
            case READ_SESSION_STORAGE:
                draft.registrationData = {
                    ...state.registrationData,
                    ...action.addressData,
                };
                break;
        }
    });

export default glasfaserRegistrationReducer;
